import z from "zod";

export const maxLookbackDays = 7;
export const thresholdInputSchema = z.object({
    amount: z
        .union([z.number(), z.undefined()], {
            invalid_type_error: "Količina mora biti broj",
        })
        .refine((val) => val !== undefined, {
            message: "Količina je obavezna",
        })
        .refine((val) => val !== undefined && val >= 1, {
            message: "Količina mora biti veća od 0",
        }),
    lookbackDays: z
        .union([z.number(), z.undefined()], {
            invalid_type_error: "Broj dana mora biti broj",
        })
        .refine((val) => val !== undefined, {
            message: "Broj dana je obavezan",
        })
        .refine((val) => val !== undefined && val >= 1, {
            message: "Broj dana mora biti veći od 0",
        })
        .refine((val) => val !== undefined && val <= maxLookbackDays, {
            message: `Broj dana ne može biti veći od ${maxLookbackDays}`,
        }),
});
